import React from 'react';
import { observer } from 'mobx-react-lite';
import type {
  ISubCategoryStatistics,
  ISiddurTopSectionStatistics,
} from '@shared/types';
import SiddurAccordion from './SiddurAccordion';
import MishnaAccordion from './MishnaAccordion';
import TanachAccordion from './TanachAccordion';
import { useBookType } from '../../../hooks/useBookAccordionData';

interface BookAccordionRouterProps {
  bookName: string;
  levelOneData: ISubCategoryStatistics | ISiddurTopSectionStatistics;
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void;
  isTeacher: boolean;
  isOnlyAccordion?: boolean;
}

/**
 * Routes to the appropriate accordion component based on book type
 * Uses the useBookType hook to determine which accordion to render
 */
const BookAccordionRouter: React.FC<BookAccordionRouterProps> = (props) => {
  const { bookName, levelOneData, onChange, ...restProps } = props;
  const bookType = useBookType(bookName);

  // Prepare accordion props
  const accordionProps = {
    ...restProps,
    onChange
  };

  // Route to appropriate accordion based on book type
  switch (bookType) {
    case 'siddur':
      return (
        <SiddurAccordion 
          bookName={bookName} 
          levelOneData={levelOneData as ISiddurTopSectionStatistics} 
          {...accordionProps}
        />
      );
    
    case 'mishna':
      return (
        <MishnaAccordion 
          bookName={bookName} 
          levelOneData={levelOneData as ISubCategoryStatistics} 
          {...accordionProps}
        />
      );
    
    case 'tanach':
    default:
      return (
        <TanachAccordion 
          bookName={bookName} 
          levelOneData={levelOneData as ISubCategoryStatistics} 
          {...accordionProps}
        />
      );
  }
};

export default observer(BookAccordionRouter);
